import axios from "axios";
import type { GetServerSideProps, InferGetServerSidePropsType } from "next";

import { BreadCrumb } from "@/components/BreadCrumb";
import type { GetCategoryDto } from "@/entities/types/entities";
import { PageLayout } from "@/layouts/PageLayout";

import { Routes } from "@/shared/constants";
import { API_BASE } from "@/shared/constants/private";
import { BuildingPage } from "@/view/Building/Building";

import Build from "@/shared/assests/backgrounds/bc.webp";

export default function Building({ sectionId, sectionNumber, cat }: InferGetServerSidePropsType<typeof getServerSideProps>) {
    const items = [{ label: "Реклама в бизнес центрах" }];

    return (
        <PageLayout
            title="Реклама в бизнес-центрах СПб | Размещение в лифтах и холлах"
            description="Эффективная реклама в бизнес-центрах: стенды, видеоэкраны, ролл-апы, лайтбоксы. Целевая аудитория - офисные сотрудники и посетители. Гибкие тарифы, аналитика эффективности!"
            page_type="service"
        >
            <BreadCrumb model={items} />
            <BuildingPage
                sectionId={sectionId}
                sectionNumber={sectionNumber}
                listCategory={cat}
                alt="BC"
                src={Build}
                url={Routes.POSTERBC}
                title="Реклама в бизнес центрах"
                description="Внимание деловой аудитории всегда на вес золота. Реклама в бизнес-центрах идеально подходит, чтобы «достучаться» до успешных и занятых людей в их профессиональной среде."
            />
        </PageLayout>
    );
}

export const getServerSideProps: GetServerSideProps = async () => {
    const sectionId = "5a6b89aa-355f-483e-921a-0abc3ae5d4dc";
    const sectionNumber = 2;

    const resCat = await axios<GetCategoryDto[]>(`${API_BASE}/category`, {
        params: { sectionId: sectionId, onlyPublished: true } }).catch(() => ({ data: [] }))

    return {
        props: {
            sectionId: sectionId,
            sectionNumber: sectionNumber,
            cat: resCat.data,
        },
    };
};
